var _path, _rect, _path2, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBathtub = function SvgBathtub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M18.5 13a3.5 3.5 0 0 1-3.5 3.5H5A3.5 3.5 0 0 1 1.5 13v-2.5h17z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 1,
    y: 10,
    fill: "currentColor",
    rx: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14 1a3 3 0 0 1 3 3v7h-6v-1h5V4a2 2 0 1 0-4 0v.5a.5.5 0 0 1-1 0V4a3 3 0 0 1 3-3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 1,
    x: 10,
    y: 4,
    fill: "currentColor",
    rx: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M6.5 18a.5.5 0 0 1-.5.5h-.5A.5.5 0 0 1 5 18v-1.5h1.5zM15 18a.5.5 0 0 1-.5.5H14a.5.5 0 0 1-.5-.5v-1.5H15z"
  })));
};
export default SvgBathtub;